import React from 'react';
import './HeroRating.css';
import StarRating from './StarRating';

// Remove local avatar imports
// import avatar1 from '../assets/images/avatar-1.png';
// ... etc ...

// Use the same pravatar URLs as ThreeColumnVideos
const avatars = [
  '/images/reviewers/cory.jpg',
  '/images/reviewers/sarah.jpg',
  '/images/reviewers/emilio.jpg',
  '/images/reviewers/nogo.jpg',
  '/images/reviewers/comedreams.jpg'
];

const ratingValue = 4.5; // Example rating
const generationCount = 35;
const additionalUsers = 9; // Example count for the last bubble

const HeroRating = () => {
  return (
    <div className="hero-rating">
      <p className="rating-text">
        <strong>{ratingValue}/5</strong> rating over {generationCount.toLocaleString()} generations
      </p>
      <div className="face-pile">
        {avatars.map((avatarUrl, index) => ( // Use avatarUrl
          <img key={index} src={avatarUrl} alt={`User ${index + 1}`} className="face-pile-avatar" />
        ))}
        {additionalUsers > 0 && (
          <div className="face-pile-more">
            +{additionalUsers}
          </div>
        )}
      </div>
      <StarRating rating={ratingValue} /> 
    </div>
  );
};

export default HeroRating; 